<div class="header-search-form">
    <div class="select-box">
        <input type="number" [(ngModel)]="pointDto.altitude" (keyup.enter)="changeAltitude()" placeholder="{{ 'search.altitudePlaceHolder' | translate }}" />
    </div>
    <div class="input-box">
        <input type="text" [(ngModel)]="pointDto.address" (keyup.enter)="search(false)" placeholder="{{ 'search.addressPlaceHolder' | translate }}" />
        <a class="header-search-btn" (click)="search(false)"></a>
        <a class="clear-btn" *ngIf="isTypedAddress()" (click)="clear()"></a>
    </div>
</div>
<div class="header-gps-box">
    <a class="gps-btn" [attr.isIgnoreElement]="true" (click)="getGeolocation(false)"></a>
</div>
<article class="search-layer" [class.hidden]="!isLayerVisible">
    <div class="search-layer-wrap">
        <div class="tabs-group" [class.hidden]="nowTabCode == tabCode.BOOKMARK_MANAGER || isSearchResultListVisible">
            <div class="tabs-selector">
                <a [class.on]="nowTabCode == tabCode.LOCATION" (click)="setTabCode(tabCode.LOCATION)">
                    {{ "search.searchHistory.title" | translate }}
                </a>
                <a [class.on]="nowTabCode == tabCode.BOOKMARK_LIST" (click)="setTabCode(tabCode.BOOKMARK_LIST)">
                    {{ "search.bookmark.title" | translate }}
                </a>
            </div>
            <location [class.hidden]="nowTabCode != tabCode.LOCATION" (addBookmarkEvent)="showBookmarkManager($event)" (locationClickEvent)="onPointClick($event)" (closeEvent)="closeLayer()"></location>
            <bookmarkList [class.hidden]="nowTabCode != tabCode.BOOKMARK_LIST" (editBookmarkEvent)="showBookmarkManager($event)" (bookmarkClickEvent)="onPointClick($event)" (closeEvent)="closeLayer()"></bookmarkList>
        </div>
        <bookmarkManager [class.hidden]="nowTabCode != tabCode.BOOKMARK_MANAGER || isSearchResultListVisible" [pointDto]="bookmarkDto" (closeEvent)="closeBookmarkManage()"></bookmarkManager>
        <div class="result-group" [class.hidden]="!isSearchResultListVisible">
            <div class="result-tit-box">
                <span class="txt">
                    {{ "search.geocoding.result" | translate }} : 
                    <b>
                        {{ geocodingResponseList.length }}
                    </b>
                    {{ "search.geocoding.count" | translate }}
                </span>
            </div>
            <div class="result-list">
                <ul>
                    <li *ngFor="let geocodingResponse of geocodingResponseList">
                        <a (click)="setLocation(geocodingResponse)" [attr.isIgnoreElement]="true">
                            <div class="top-box" [attr.isIgnoreElement]="true">
                                {{ geocodingResponse.address }}
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="layer-menu-box">
                <a class="search-layer-close" (click)="closeSearchResult()">
                    {{ "search.unfold" | translate }}
                </a>
            </div>
        </div>
    </div>
</article>